export default __webpack_public_path__ + "static/media/settings-white.1e8467da.svg";